import { RestSlice } from '../../../../../redux/rest.slice';
import { IppDataSourceCollectionMethod } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippCollectionMethodSlice = new RestSlice<IppDataSourceCollectionMethod>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.translations.collectionMethods.heading'),
	Resource.IppDataSourceCollectionMethods
);
export default ippCollectionMethodSlice.rests.reducer;
